import Vue from 'vue'
import VueResource       from 'vue-resource';

import './plugins/bootstrap-vue'

import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue.use(VueResource);

if(localStorage.getItem('access_token') != '' ){
  store.commit('SET_SESSION');
}


Vue.http.options.root = 'https://glacial-citadel-61741.herokuapp.com';
Vue.http.interceptors.push((request, next) => {
  request.headers.set('Authorization', store.getters['TOKEN'])
  next(res => {                                                                                                                                                                                                                                                                                                                    
      if (res.status === 401 || res.status === 403) {
          router.push('/');
      }
  })
})


router.beforeEach((to, from, next) => {
  // const hasAccess = false
  const isLoggedIn = store.getters['ISLOGGED'] 

  if(to.name != 'login'){
    if(!isLoggedIn){
      return next({name: 'login'})
    }
    // if(!hasAccess){
    //   return next({name: 'login'})
    // }
  }

  if(to.name == 'base-route' && isLoggedIn){
    return next({name: 'dashboard-home'})
  }

  next(vm => vm.setData(err, post))
})


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
